module.exports = __webpack_public_path__ + "static/45-8597db9934f3c76ec30520f62c2b3534.jpg";